<template>
    <div>
        <a-button type="primary" @click="showModal">
            Open Modal with async logic
        </a-button>
    <a-modal
            title="Title"
            :visible="visible"
            :confirm-loading="confirmLoading"
            :width="'1700'"
            @ok="handleOk"
            @cancel="handleCancel"
    >
        <edit-form></edit-form>
    </a-modal>
    </div>
</template>

<script>
    import EditForm from '../../BAK/index'
    export default {
        name: "FormModel",
        components:{EditForm},
        data() {
            return {
                ModalText: 'Content of the modal',
                visible: false,
                confirmLoading: false,
            };
        },
        methods: {
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.ModalText = 'The modal will be closed after two seconds';
                this.confirmLoading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.confirmLoading = false;
                }, 2000);
            },
            handleCancel(e) {
                console.log('Clicked cancel button');
                this.visible = false;
            },
        },
    }
</script>

<style scoped>

</style>